export default "__VITE_ASSET__1f857eb6__"